import { render, staticRenderFns } from "./CustomerBindStaff.vue?vue&type=template&id=636afae8&scoped=true&"
import script from "./CustomerBindStaff.vue?vue&type=script&lang=js&"
export * from "./CustomerBindStaff.vue?vue&type=script&lang=js&"
import style0 from "./CustomerBindStaff.vue?vue&type=style&index=0&id=636afae8&lang=scss&scoped=true&"
import style1 from "./CustomerBindStaff.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636afae8",
  null
  
)

export default component.exports